<template>
  <v-footer>
    <div class="ml-auto">
      <span class="ml-1">Powered by ESYMED Co.,Ltd</span>
    </div>
  </v-footer>
</template>
<script>

export default {
  name: "DefaultFooter",
  components: {
  }
};
</script>
